import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";
import { AdminLogin, AdminDashboard } from "@/pages/Admin";
import { Toaster } from "sonner";

export default function App() {
  return (
    <I18nProvider>
      <div className="App">
        <Toaster richColors position="top-center" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/report/:token" element={<Report />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}
